<template>
  <form class="" @submit.prevent="handleSubmit">
    <div class="form-group col-md-6">
      <label for="name">Nom</label>
      <input
        v-model="country.name"
        type="text"
        class="form-control"
        id="name"
        placeholder="Nom"
        disabled
      />
    </div>
    <div class="form-group col-md-6">
      <label for="code_iso">Code ISO</label>
      <input
        v-model="country.code_iso"
        type="text"
        class="form-control"
        id="code_iso"
        placeholder="code iso"
        disabled
      />
    </div>

    <!-- <div class="form-group col-md-6">
      <label for="state">Etat</label>
      <select id="state" class="form-control" v-model="country.state" disabled>
        <option disabled value="">Sélectionner un état...</option>
        <option value="AUTHORIZED">AUTHORISE</option>
        <option value="UNAUTHORIZED">NON AUTHORISE</option>
      </select>
    </div> -->
    <div class="form-group col-md-6">
      <label for="indicatif">Indicatif</label>
      <input
        v-model="country.indicatif"
        type="text"
        class="form-control"
        id="indicatif"
        placeholder="Indicatif"
        disabled
      />
    </div>
    <div class="form-group col-md-6">
      <div class="form-check">
        <input
          v-model="country.state"
          class="form-check-input"
          type="checkbox"
          id="state"
          disabled
        />
        <label class="form-check-label" for="state"> Etat </label>
      </div>
    </div>
    <div class="form-group col-md-6">
      <div class="form-check">
        <input
          v-model="country.automatic_visa_generation"
          class="form-check-input"
          type="checkbox"
          id="automatic_visa_generation"
          disabled
        />
        <label class="form-check-label" for="automatic_visa_generation">
          Génération automatique de visa ?
        </label>
      </div>
    </div>
    <router-link
      class="btn btn-dark action-btn-cancel"
      :to="{ name: 'countries' }"
    >
      Retourner
    </router-link>
  </form>
</template>

<script>
import { FETCH_COUNTRY } from "@/store/actions.type";
export default {
  name: "CountryViewForm",
  data() {
    return {
      country: {},
    };
  },
  async mounted() {
    let countryId = this.$route.params.id;

    if (countryId && countryId !== "undefined") {
      this.country = await this.getCountry(countryId);
    }
  },

  methods: {
    async getCountry(id) {
      return await this.$store.dispatch(FETCH_COUNTRY, id);
    },
  },
};
</script>